<template>
  <div style="padding: 0 10px;box-sizing: border-box;">
    <el-row :gutter="20" style="margin-top: 10px;margin-right:0;">
      <el-col :span="7">
        <div class="grid-content bg-purple">
          <el-alert title="标签管理" type="info" :closable="false"></el-alert>
          <el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border :data="tagData" style="width: 100%" size="small">
          <el-table-column prop="code" label="编码"show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态">
              <template slot-scope="scope"> {{ scope.row.status == '1' ? '停用' : '正常' }}</template>
          </el-table-column>
          <el-table-column prop="ops" label="操作" fixed="right"> 
              <template slot="header" slot-scope="scope">
                 <el-button icon="el-icon-plus" @click="addTag" size="mini">新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="editTag(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteTagFunc(scope.row)" v-if="scope.row.code != 'reimbursed'" type="text" size="small">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="grid-content bg-purple">
          <el-alert title="单位管理" type="info" :closable="false"></el-alert>
          <el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#606266',height:'54px'}" border :data="unitData" style="width: 100%" size="small">
          <el-table-column prop="unitCode" label="单位编码" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unitName" label="单位名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="nsrsbh" label="纳税识别号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="管理账户" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="80" show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.status == '1' ? '停用' : '正常' }}</template>
          </el-table-column>
          <el-table-column prop="ops" label="操作" fixed="right" width="210"> 
              <template slot="header" slot-scope="scope">
                 <el-button icon="el-icon-plus" @click="addUnit" size="mini">新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="editUnit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="showUnitUsers(scope.row)" type="text" size="small">管理员</el-button>
                <el-button @click="deleteUnitFunc(scope.row)" type="text" size="small">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="grid-content bg-purple">
          <el-alert title="系统账户管理" type="info" :closable="false"></el-alert>
          <el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#333'}" border :data="accountData" style="width: 100%" size="small">
            <el-table-column prop="userName" label="用户名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="手机号码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nickName" label="昵称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ops" label="操作" fixed="right" width="150"> 
                <template slot="header" slot-scope="scope">
                  <el-button icon="el-icon-plus" @click="addAccountDialog" size="mini">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button @click="editAccountDialog(scope.row)" type="text" size="small">编辑</el-button>
                  <el-button @click="resetPassword(scope.row)" type="text" size="small">重置密码</el-button>
                  <el-button @click="deleteAccountFunc(scope.row)" v-if="scope.row.userName != 'root'" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row>

      <el-col :span="7">
        <el-alert title="标签管理" type="info" :closable="false" style="width: 99%;"></el-alert>
        <el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#333'}" border :data="tagData" style="width: 100%" size="small">
          <el-table-column prop="code" label="编码" width="155" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="名称" width="155" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope"> {{ scope.row.status == '1' ? '停用' : '正常' }}</template>
          </el-table-column>
          <el-table-column prop="ops" label="操作" fixed="right" width="120"> 
              <template slot="header" slot-scope="scope">
                 <el-button icon="el-icon-plus" @click="addTag" size="mini">新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="editTag(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteTagFunc(scope.row)" v-if="scope.row.code != 'reimbursed'" type="text" size="small">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
      </el-col>

      <el-col :span="10">
        <el-alert title="单位管理" type="info" :closable="false" style="width: 99%;"></el-alert>
        <el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#333'}" border :data="unitData" style="width: 100%" size="small">
          <el-table-column prop="unitCode" label="单位编码" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unitName" label="单位名称" width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="nsrsbh" label="纳税识别号" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="管理账户" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" width="80" show-overflow-tooltip>
              <template slot-scope="scope"> {{ scope.row.status == '1' ? '停用' : '正常' }}</template>
          </el-table-column>
          <el-table-column prop="ops" label="操作" fixed="right" width="210"> 
              <template slot="header" slot-scope="scope">
                 <el-button icon="el-icon-plus" @click="addUnit" size="mini">新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="editUnit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="showUnitUsers(scope.row)" type="text" size="small">管理员</el-button>
                <el-button @click="deleteUnitFunc(scope.row)" type="text" size="small">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
      </el-col>

      <el-col :span="7">
        <el-alert title="系统账户管理" type="info" :closable="false" style="width: 99%;"></el-alert>
        <el-table :header-cell-style="{fontSize: '14px', backgroundColor: '#f8f8f8',color:'#333'}" border :data="accountData" style="width: 100%" size="small">
          <el-table-column prop="userName" label="用户名" width="85" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone" label="手机号码" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="nickName" label="昵称" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ops" label="操作" fixed="right" width="150"> 
              <template slot="header" slot-scope="scope">
                 <el-button icon="el-icon-plus" @click="addAccountDialog" size="mini">新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="editAccountDialog(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="resetPassword(scope.row)" type="text" size="small">重置密码</el-button>
                <el-button @click="deleteAccountFunc(scope.row)" v-if="scope.row.userName != 'root'" type="text" size="small">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row> -->


  <!-- 编辑标签 -->
  <edit-tag-dialog :tagInfo="tagInfo"  :dialogVisible="tagDialogVisible" @closeTagDialog="closeTagFunc"></edit-tag-dialog>

  <!-- 编辑单位 -->
  <edit-unit-dialog :unitInfo="unitInfo"  :dialogVisible="unitDialogVisible" @closeUnitDialog="closeUnit"></edit-unit-dialog>

  <!-- 单位用户 -->
  <unit-sys-user-dialog :selectUnitId="selectUnitId" :selectUnitCode="selectUnitCode" :deptOptions="selectDeptOptions" :dialogVisible="userDialogVisible" @close="closeUserDialog"></unit-sys-user-dialog>

  <!-- 新增系统用户 -->
  <edit-system-account-dialog :accountInfo="accountInfo" :dialogVisible="accountDialogVisible" @closeAccountDialog="closeAccount"></edit-system-account-dialog>
  




  <read-excel-dialog :dialogVisible="readExcelVisible" @close="closeEeadExcelDialog"></read-excel-dialog>

  </div>
</template>

<script>
import { findTags,deleteTag } from "@/api/dict";
import { listUnit,deleteById } from "@/api/unit";
import { Message,MessageBox } from 'element-ui';
import { listSysAccount,resetSystemAccountPassword,deleteAccountById } from '@/api/account';

import ReadExcelDialog from './dialog/ReadExcelDialog.vue';
import EditTagDialog from './dialog/EditTagDialog.vue';
import EditUnitDialog from './dialog/EditUnitDialog.vue';
import EditSystemAccountDialog from './dialog/EditSystemAccountDialog.vue'
import UnitSysUserDialog from './dialog/UnitSysUserDialog.vue';

export default {
  name: "SystemConfigure",
  components:{ ReadExcelDialog , EditTagDialog , EditUnitDialog , EditSystemAccountDialog,UnitSysUserDialog },
  data() {
    return {

      tagData: [], 
      tagDialogVisible: false,
      tagInfo: {
        id : "",
        code : "",
        name : "",
        status : "",
        disabledCode: false
      },

      unitData: [],
      unitDialogVisible: false,
      unitInfo: {
        id : '',
        unitCode:'',
        unitName:'',
        nsrsbh:'',
        showClose: false,
        uneditUnitCode:false,
        uneditNsrsbh:false,
        mustVerify:''
      },

      selectUnitId: null,
      selectUnitCode: null,
      selectDeptOptions : [],
      userDialogVisible: false,

      accountData: [],
      accountDialogVisible: false,
      accountInfo : {
        id: '',
        email : '',
        phone:'',
        userName:'',
        showPasseord:true,
        disabledUserName:false,
        disabledPhone: false,
      },

      readExcelVisible: false

    };
  },
  created(){
    this.listTags();
    this.listUnitFunc();
    this.listSysAccountFunc();
  },
  methods: {

    closeEeadExcelDialog(){
        this.readExcelVisible = false;
    },

    //查询标签
    listTags(){
      findTags().then(res => {
        this.tagData = res.data;
      });
    },

    //新增标签
    addTag(){
       this.tagInfo.id = '';
       this.tagInfo.code = '';
       this.tagInfo.name = '';
       this.tagInfo.disabledCode = false;
       this.tagDialogVisible = true
    },

    //编辑
    editTag(row){
       this.tagInfo = {...row};
       this.tagInfo.disabledCode = true;
       this.tagDialogVisible = true;
    },

    //删除标签
    deleteTagFunc(tag){
      var _this = this;
      MessageBox.confirm('此操作将永久删除该标签, 是否继续?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
         deleteTag(tag).then(res => {
            if(res.code == 200){
                Message.success('删除成功');
                _this.listTags();
            } else {
                Message.error(res.msg);
            }
         });  
      }).catch(() => {
                 
      });
    },

    //关闭弹窗
    closeTagFunc(){
       this.tagDialogVisible = false;
       this.listTags();
    },

    //单位列表
    listUnitFunc(){
        let param = {
            pageNum: 1,
            pageSize: 2000
        }
        listUnit(param).then(res => {
            this.unitData = res.data.content;
        });
    },
  
    //新增单位
    addUnit(){
       this.unitInfo.id = '';
       this.unitInfo.unitCode = '';
       this.unitInfo.unitName = '';
       this.unitInfo.nsrsbh = '';
       this.unitInfo.uneditUnitCode = false
       this.unitInfo.uneditNsrsbh = false
       this.unitDialogVisible = true
    },

    //关闭添加单位
    closeUnit(){
      this.unitDialogVisible = false
      this.listUnitFunc();
    },

    //编辑单位
    editUnit(row){
        this.unitInfo = {...row};
        this.unitInfo.showClose = false;
        this.unitInfo.uneditUnitCode = true
        this.unitInfo.uneditNsrsbh = true
        this.unitDialogVisible = true;
    },

    //删除单位
    deleteUnitFunc(row){
      var _this = this;
      MessageBox.confirm('此操作将永久删除该单位, 是否继续?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
        deleteById({id:row.id}).then(res => {
            if(res.code == 200){
                Message.success('删除成功');
                _this.listUnitFunc();
            } else {
                Message.error(res.msg);
            }
         });  
      }).catch(() => {
                 
      });
    },

    //单位用户
    showUnitUsers(row) {
        console.log(row);
        this.selectUnitId = row.id;
        this.selectUnitCode = row.unitCode;
        this.selectDeptOptions = [{ id: row.id , label:row.unitName }];
        this.userDialogVisible = true;
    },
    closeUserDialog(){
      this.userDialogVisible = false;
    },

    //系统账户
    listSysAccountFunc(){
      listSysAccount({}).then(res => {
          this.accountData = res.data;
      })
    },
    
    //添加系统用户
    addAccountDialog(){
      this.accountInfo = {
          id: '',
          email : '',
          phone:'',
          userName:'',
          password: '',
          showPasseord:true,
          disabledUserName:false,
          disabledPhone: false,
      }
      this.accountDialogVisible = true
    },
    //编辑系统用户
    editAccountDialog(row){
        this.accountInfo = {
            id: row.id,
            email : row.email,
            phone: row.phone,
            userName:row.userName,
            nickName: row.nickName,
            showPasseord:false,
            disabledUserName:true,
            disabledPhone: true,
        }
        this.accountDialogVisible = true
    },
    //关闭
    closeAccount(){
        this.accountDialogVisible = false;
        this.listSysAccountFunc();
    },
    //重置密码
    resetPassword(row){
      let id = row.id;
      MessageBox.prompt('请输入重置后密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator:(val) => {
              if(val == '' || val == null){
                  return '密码不能为空';
              }
          }
      }).then(({ value }) => {
        resetSystemAccountPassword({id:id,password:value}).then(res => {
            if(res.code == 200){
               Message.success("操作成功"); 
            } else {
               Message.success(res.msg); 
            }
        });
      }).catch(() => {
               
      });
    },
    //删除系统用户
    deleteAccountFunc(row){
        var _this = this;
        MessageBox.confirm('此操作将永久删除该系统管理员, 是否继续?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
          deleteAccountById({id:row.id}).then(res => {
              if(res.code == 200){
                  Message.success('删除成功');
                  _this.listSysAccountFunc();
              } else {
                  Message.error(res.msg);
              }
          });  
        }).catch(() => {
                  
        });
    },




  },
};
</script>

<style scoped>
.register-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 10px #cac6c6;
  z-index: 99;
  .title {
    margin: 0px auto 40px auto;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}
.el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
   border: 1px solid #f3f3f3;
   padding: 10px;
   box-sizing: border-box;
  }
  .bg-purple-light {
    /* background: #e5e9f2; */
  }
  .grid-content {
    border-radius: 4px;
    min-height: 770px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>


// WEBPACK FOOTER //
// src/views/components/SystemConfigure.vue